import { PlaceholderPage } from '../../components/PlaceholderPage/PlaceholderPage';

export const Audit = () => (
  <PlaceholderPage
    title="Audit"
    description="Every staff action: who, what, which tenant, before and after."
  />
);
